import React, { useEffect, useState } from 'react'
import { Col, Form } from "react-bootstrap";
import { FiCheckCircle, FiDownload, FiFileText, FiUploadCloud, FiLock, FiSend } from "react-icons/fi";
import { ToastContainer, toast } from 'react-toastify';
import TdsDialoge from "../../../../../../../components/Dialog/tdsDialoge"
import { Check, Cross, Pause, PencilLine } from '../../../../../../../components/icons/Icons';
import { useDispatch } from 'react-redux';
import { useSelect } from '../../../../../../../services/commonServices';
import { tdsRequestFormPath } from '../../../../../../../services/config';
import { initStatusState, saveTdsStatusData } from '../../../../../../../redux/slices/tdsSlice';

const RightSidebar = ({ staffId, reviewTdsDeclaration, haldleChangeOldNewRegime }) => {

    const currentUser = JSON.parse(localStorage.getItem("tdsUser") || "{}")?.staffId || ""

    const [isRequestEdit, setIsRequestEdit] = useState(false)
    const [isApproved, setIsApproved] = useState(false)
    const [isHold, setIsHold] = useState(false)
    const [isRejected, setIsRejected] = useState(false)

    const [quickPresets, setQuickPresets] = useState("3 days")

    const user = JSON.parse(localStorage.getItem("user_data")) || {}
    const tdsStore = useSelect("tds")
    const dispatch = useDispatch()

    const [updateStatus, setUpdateStatus] = useState({
        userId: user.user_id,
        staffId: staffId,
        status: "1"
    })

    const [issuesToAddress, setIssuesToAddress] = useState([])

    const handleAddress = ({ target: { checked, value } }) => {
        setIssuesToAddress((prev) => {
            if (checked) {
                // add value if not already present
                return [...prev, value];
            } else {
                // remove value if unchecked
                const updated = prev.filter((v) => v !== value);
                return updated;
            }
        });
    };

    const submitStatus = (e) => {
        e.preventDefault()
        const formData = {
            path: tdsRequestFormPath,
            data: {
                ...updateStatus,
                form12bAddressType: issuesToAddress.toString(),
            }
        }
        dispatch(saveTdsStatusData(formData))
    }

    useEffect(() => {
        if (tdsStore.tdsStatusSuccess) {
            // toast.success(tdsStore.tdsStatusMessage)
            dispatch(initStatusState())
        }
        if (tdsStore.tdsStatusError) {
            // toast.error(tdsStore.tdsStatusMessage)
            dispatch(initStatusState())
        }
    }, [tdsStore])

    const SmartCheck = ({ color, label, amount }) => (
        <div className={`erd-smart ${color}`}>
            <div className="erd-smart-left">
                <span className="erd-dot" />
                <span className="erd-smart-text color-white font-weight-200">{label}</span>
            </div>
            <div className="erd-smart-right">
                {amount ? <span className="erd-amt">{amount}</span> : <FiCheckCircle />}
            </div>
        </div>
    );

    // --------------------------------
    const closeApproveDialog = () => {
        setIsApproved(false)
    }
    // --------------------------------
    const closeRequestEditDialog = () => {
        setIsRequestEdit(false)
    }
    const submitRequestEditForm = () => { }
    // --------------------------------
    const closeHoldDialog = () => {
        setIsHold(false)
    }
    const submitHoldForm = () => { }
    // --------------------------------
    const closeRejectDialog = () => {
        setIsRejected(false)
    }
    const submitRejectForm = () => { }

    return (
        <Col sm={3} className="erd-rightbar">
            <div className="erd-right-inner">
                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Smart Checks</div>
                    <SmartCheck color="g" label="HRA Formula" />
                    <SmartCheck color="b" label="Landlord PAN" />
                    <SmartCheck color="g" label="87A Rebate" />
                    <SmartCheck color="y" label="Proof Sufficiency" />
                    <SmartCheck color="o" label="TDS Delta" amount="₹2.3k" />
                </div>

                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Quick Actions</div>
                    <div className="d-grid gap-2">
                        <button style={{ height: "40px" }} className="d-flex align-items-center justify-content-center gap-2 universal-btn-green border-radius-8px g" onClick={() => setIsApproved(true)}> <Check /> <span>Approve (A)</span></button>
                        <button style={{ height: "40px" }} className="d-flex align-items-center justify-content-center gap-2 universal-btn-yellow border-radius-8px o" onClick={() => setIsRequestEdit(true)}> <PencilLine /> <span>Request Edit (R)</span></button>
                        <button style={{ height: "40px" }} className="d-flex align-items-center justify-content-center gap-2 universal-btn-info border-radius-8px y" onClick={() => setIsHold(true)}> <Pause /> <span>Put On Hold (H)</span></button>
                        <button style={{ height: "40px" }} className="d-flex align-items-center justify-content-center gap-2 universal-btn-red border-radius-8px r" onClick={() => setIsRejected(true)}> <Cross /> <span>Reject</span></button>
                    </div>
                </div>

                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Request from Employee</div>
                    <div className="erd-checks">
                        {['Landlord PAN', 'Missing Receipts', 'Insurance Certificate', 'Clarify Amount'].map((t, i) => (
                            <Form.Check
                                key={t}
                                value={i+1}
                                type="checkbox"
                                label={t}
                                className='color-white font-weight-200'
                                onChange={handleAddress}
                            />
                        ))}
                    </div>
                    <button className="erd-btn border-radius-8px universal-btn p w-100 mt-2" onClick={submitStatus}><FiSend /> <span>Send Request</span></button>
                </div>

                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Finalize</div>
                    <div className="d-grid gap-2">
                        <button className="erd-btn border-radius-8px p universal-btn"><FiLock /> <span>Lock & Push to Payroll</span></button>
                        <button className="erd-btn border-radius-8px p universal-sec-btn "><FiUploadCloud /> <span>Attach Form 16</span></button>
                        <button className="erd-btn border-radius-8px universal-sec-btn outline r"><span>Re-issue Form 16</span></button>
                    </div>
                </div>

                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Export Options</div>
                    <div className="d-grid gap-2">
                        <button className="erd-btn border-radius-8px p universal-sec-btn"><FiDownload /> <span>Download 12BB PDF</span></button>
                        <button className="erd-btn border-radius-8px p universal-sec-btn"><FiFileText /> <span>Export Calc Sheet</span></button>
                        {/* <button className="erd-btn border-radius-8px p universal-sec-btn"><FiDownload /> <span>Case File (ZIP)</span></button> */}
                    </div>
                </div>

                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Keyboard Shortcuts</div>
                    <ul className="erd-short color-white font-weight-200">
                        <li>A - Approve</li>
                        <li>R - Request Edit</li>
                        <li>H - Hold</li>
                        <li>V - Verify</li>
                        <li>T - Recalculate</li>
                    </ul>
                </div>
            </div>

            <TdsDialoge
                staffId={staffId}
                isApproved={isApproved}
                closeApproveDialog={closeApproveDialog}
                isRequestEdit={isRequestEdit}
                closeRequestEditDialog={closeRequestEditDialog}
                submitRequestEditForm={submitRequestEditForm}
                quickPresets={quickPresets}
                setQuickPresets={setQuickPresets}
                isHold={isHold}
                closeHoldDialog={closeHoldDialog}
                submitHoldForm={submitHoldForm}
                isRejected={isRejected}
                closeRejectDialog={closeRejectDialog}
                submitRejectForm={submitRejectForm}
            />
        </Col>
    )
}

export default RightSidebar